/* ============================================================================
   Title reveal — masked letter slide-up (no fade). Pure CSS animation +
   IntersectionObserver, NO GSAP.

   Each title/subtitle is split into words (overflow-hidden masks) → letters. Each
   letter carries a --tr-i index; the CSS animation (base.css .tr-in .tr-char)
   staggers them up when the title's element gets the .tr-in class. IO adds .tr-in
   as the title scrolls into view (immediately for above-the-fold titles).

   There is NO visibility gate: letters start masked via CSS transform, so a title
   can never be left hidden — worst case it simply shows without animating. A safety
   timer also force-reveals anything still masked. Loaded deferred, so the DOM is
   parsed when this runs — split happens right away to minimise any flash.
   ========================================================================== */
(function () {
  var SELECTOR = [
    '.section-title',
    '.hero-carousel__title', '.hero-carousel__subtitle',
    '.cc__title', '.cc__subtitle',
    '.cg__title', '.cg__eyebrow',
    '.ct__title', '.ct__subtitle',
    '.pm__title', '.pm__subtitle',
    '.wishlist__title',
    '.product-list__title', '.product-list__subtitle',
    '.lc__title', '.lc__eyebrow',
    '.banner__title',
    '.feature-banner__title', '.feature-banner__subtitle',
    '.more-about__title', '.more-about__subtitle',
    '.newsletter__title', '.newsletter__subtitle',
    '.blog__title', '.rr__title', '.sg__title', '.fl__title',
    '.sfa__title'
  ].join(',');

  function splitNode(node, chars) {
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(node.childNodes, function (child) {
      if (child.nodeType === 3) {
        var parts = child.textContent.split(/(\s+)/);
        parts.forEach(function (part) {
          if (part === '') return;
          if (/^\s+$/.test(part)) {
            // Wrap the space in a real element with a non-breaking space. A bare
            // whitespace-only text node directly inside a display:flex title (e.g.
            // .product-list__title) is dropped by flex layout → words run together.
            var sp = document.createElement('span');
            sp.className = 'tr-space';
            sp.style.whiteSpace = 'pre-wrap';
            sp.textContent = ' ';
            frag.appendChild(sp);
            return;
          }
          var word = document.createElement('span');
          word.className = 'tr-word';
          Array.prototype.forEach.call(part, function (ch) {
            var c = document.createElement('span');
            c.className = 'tr-char';
            c.textContent = ch;
            chars.push(c);
            word.appendChild(c);
          });
          frag.appendChild(word);
        });
      } else if (child.nodeType === 1) {
        if (child.tagName === 'BR') { frag.appendChild(child.cloneNode()); return; }
        if (child.tagName === 'IMG') {
          var w = document.createElement('span'); w.className = 'tr-word';
          var img = child.cloneNode(true); img.classList.add('tr-char');
          chars.push(img); w.appendChild(img); frag.appendChild(w); return;
        }
        var shell = child.cloneNode(false);
        shell.appendChild(splitNode(child, chars));
        frag.appendChild(shell);
      }
    });
    return frag;
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('tr-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px' }) : null;

  function split() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.__trBound || !el.textContent.trim() || el.closest('[data-tr-skip]')) return;
      el.__trBound = true;
      try {
        var chars = [];
        var frag = splitNode(el, chars);
        el.textContent = '';
        el.appendChild(frag);
        chars.forEach(function (c, i) { c.style.setProperty('--tr-i', Math.min(i, 28)); });
        if (!chars.length) { el.classList.add('tr-in'); return; }
        if (io) io.observe(el); else el.classList.add('tr-in');
      } catch (e) { el.classList.add('tr-in'); }
    });
  }

  var pending = false;
  function schedule() { if (pending) return; pending = true; setTimeout(function () { pending = false; split(); }, 60); }

  function boot() {
    split();
    // Safety net: reveal anything still masked after a few seconds (e.g. if IO never fired).
    setTimeout(function () {
      document.querySelectorAll(SELECTOR).forEach(function (el) { if (el.__trBound) el.classList.add('tr-in'); });
    }, 3500);
    // Re-process titles injected later (recommendations, filter re-render, editor loads).
    if (window.MutationObserver && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', schedule);
})();
